import { FinalizedHoursDto } from 'types/dashboard';
import { portalAPI } from './portalAPI';

const APIDashboardSlice = portalAPI
    .enhanceEndpoints({
        addTagTypes: ['DashboardFinalizedHours'],
    })
    .injectEndpoints({
        endpoints: (builder) => ({
            getFinalizedHours: builder.query<FinalizedHoursDto, { dateFrom: string; dateTo: string }>({
                query: ({ dateFrom, dateTo }) => `/v1/dashboard/finalized-hours?fromDate=${dateFrom}&toDate=${dateTo}`,
                keepUnusedDataFor: 0,
                providesTags: ['DashboardFinalizedHours'],
            }),
        }),
        overrideExisting: false,
    });

export const { useGetFinalizedHoursQuery } = APIDashboardSlice;
